import { useEffect, useState } from 'react'
import { useUpdatingRef } from 'utils/hooks/useUpdatingRef'

const useMemoComparator = (nextValueOrGetter, comparator) => {
  const [value, setValue] = useState(nextValueOrGetter)
  const comparatorRef = useUpdatingRef(comparator)

  useEffect(() => {
    setValue(currentValue => {
      const nextValue =
        typeof nextValueOrGetter === 'function'
          ? nextValueOrGetter()
          : nextValueOrGetter
      return comparatorRef.current(currentValue, nextValue)
        ? currentValue
        : nextValue
    })
  }, [comparatorRef, nextValueOrGetter])
  return value
}
export default useMemoComparator
